export const promiseWrapper: (promise: any) => any = (promise) => {
  return new Promise((resolve) => {
    promise
      .then((resp: any) => resp.json())
      .then((resp: any) => {
        resolve([null, resp]);
      })
      .catch((err: any) => {
        resolve([err, null]);
      });
  });
};
